export { default as WhiteboardSolidIcon } from './WhiteboardSolidIcon';
